export const ValidationErrorCodes = {
    CHECKLIST: {
        FORM_ACTION_USER: "FormActionUser",
    },
}